import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'
import { urlEncodeQuery } from '@/features/shared/tools'
import type { PagedRequest, QueryBase } from '@/features/interface/recherches/shared/composables/storeRechercheBuilder.ts'
import type { IPagedResponse, PaginationParam } from '@/features/api/extranet'

export async function loadRecherche<TRequest extends QueryBase, TResponse extends object>(
  apiPath: string,
  request: PagedRequest<TRequest>,
  init?: RequestInit,
): Promise<IPagedResponse<TResponse>> {
  init = { sablier: true, dialogMode: 'retry', ...init }

  const fetch = useFetch('extranet')

  const queryPagination: PaginationParam = {
    pageNumber: (request.pagination?.pageNumber ?? 1) - 1,
    pageSize: request.pagination?.pageSize,
  }

  const queryString = urlEncodeQuery({
    ...request.query,
    orderBy: request.orderBy,
    ...queryPagination,
  })

  const response = await fetch(`${apiPath}${queryString}`, init)

  ensureSuccessStatusCode(response)
  return (await response.json()) as IPagedResponse<TResponse>
}

export async function printRecherche<TRequest extends object>(
  apiPath: string,
  request: PagedRequest<TRequest>,
  init?: RequestInit,
): Promise<void> {
  init = { sablier: true, dialogMode: 'retry', ...init }

  const fetch = useFetch('extranet')

  const queryString = urlEncodeQuery({
    ...request.query,
    orderBy: request.orderBy,
  })

  const response = await fetch(`${apiPath}/export${queryString}`, init)

  ensureSuccessStatusCode(response)
}
